import React, { Component, Fragment } from 'react'
import { DeleteResponseModel, LinkResourcesResponseModel } from '../../../../shared/models'
import { HttpResponse } from '../../../../core';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../../shared/helpers';
import { NavLink } from "react-router-dom";
import { ButtonType, NotFoundResponseArea } from '../../../../shared/enums';
import { ExtractionEnginesService } from './services/extraction.engines.service';
import { ExtractionEnginesTabs } from './ExtractionEnginesTabs';

interface IState {
    result?: LinkResourcesResponseModel;
    deleteResult?: DeleteResponseModel;
    isDoubleleClick?: boolean;
}
export class DeleteExtractionEngines extends Component<any, IState> {
    private service: ExtractionEnginesService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new ExtractionEnginesService();
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    initialState: Partial<IState> = {
        result: {
            id: 0,
            name: ""
        },
        deleteResult: { isdeleted: false },
        isDoubleleClick: false
    }
    componentDidMount() {
        // this.loadData();
    }

    loadData() {
        this.service.getLinkedResourcesById(this.props.match.params.id)
            .then((res: HttpResponse<LinkResourcesResponseModel>) => {
                if (res && res.result) {
                    this.setState({
                        result: res.result
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.ExtractionEngine,this.props)
            });
    }


    deleteRecord() {
        if (!this.state.isDoubleleClick) {
            this.setState({ isDoubleleClick: true })
            this.service.deleteRecordById(this.props.match.params.id)
                .then((res: HttpResponse<DeleteResponseModel>) => {
                    if (res && res.result) {
                      
                        this.setState({
                            deleteResult: res.result
                        }, () => {
                            if (this.state.deleteResult?.isdeleted) {
                                ShowSuccessMessage("Extraction engine successfully deleted.");
                                this.props.history.push('/extraction-engine/list');
                            }
                        });
                    }
                });

        }
    }
    render() {
        return (
            <Fragment>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Delete Extraction Engine '{this.props.match.params.name}'</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <ExtractionEnginesTabs id={this.props.match.params.id} url="/extraction-engine/delete/" />
                                <div className="alert font-weight-bold  alert-light"> <i className="fas fa-exclamation-circle text1"></i> Are you sure you want to delete this extraction engine  <strong>“{this.props.match.params.name}”</strong> ?</div>

                                <p className="mt-4 text-danger"><i className="fas fa-exclamation-triangle text1"></i> The following related items may be deleted or orphaned:</p>
                                <div className="row ">
                                    <div className="col-3">
                                        <div className="card card-primary shadow-sm">
                                            <div className="card-header">
                                                <h4>Extraction Engine</h4>
                                            </div>
                                            <div className="card-body">
                                                <NavLink className="badge badge-light text-link" to={"/extraction-engine/detail/" + this.props.match.params.id}>{this.props.match.params.name}</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="mx-auto">
                                <button className="btn btn-lg btn-danger" disabled={this.state.isDoubleleClick} onClick={this.deleteRecord}> {ButtonType.Delete}</button>
                                <NavLink type="button" className="btn btn-lg btn-default ml-3" to="/extraction-engine/list">{ButtonType.Cancel}</NavLink>
                            </div>
                        </div>
                    </div>

                </div>
            </Fragment>
        )
    }
}
